import { FC, HTMLAttributes, memo } from 'react';

import { cn } from '@/src/utils/cn';

type TCursor = HTMLAttributes<HTMLDivElement> & {
  isErase?: boolean;
};
export const Cursor: FC<TCursor> = memo(({ className, isErase, ...props }) => (
  <div
    className={cn(
      'pointer-events-none absolute inset-0 z-1 m-auto rounded-full',
      'border-2 border-primary-foreground',
      'will-change-auto',
      isErase ? 'bg-danger/40' : 'bg-primary/40',
      className,
    )}
    {...props}
  />
));
Cursor.displayName = 'Cursor';
